import { render, staticRenderFns } from "./StepSignaturePosition.vue?vue&type=template&id=5a1f9e18&"
import script from "./StepSignaturePosition.vue?vue&type=script&lang=js&"
export * from "./StepSignaturePosition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1f9e18')) {
      api.createRecord('5a1f9e18', component.options)
    } else {
      api.reload('5a1f9e18', component.options)
    }
    module.hot.accept("./StepSignaturePosition.vue?vue&type=template&id=5a1f9e18&", function () {
      api.rerender('5a1f9e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/wizardFlow/wizard/flow/StepSignaturePosition.vue"
export default component.exports